import {
  CONFIG_DDF,
  CONFIG_DDF_SMAVA,
  CONFIG_DDF_RCE_DAC_CHOICE,
  ConfigName,
  CONFIGS_WITH_AGE_BASED_TIMEOUT
} from 'config/utils/config'
import { AgeGroup } from 'constants/components'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'

export const TIMEOUT_ONE_MINUTE = 60000 // 1 minute
export const TIMEOUT_TWO_MINUTES = 120000 // 2 minutes
export const TIMEOUT_THREE_MINUTES = 180000 // 3 minutes
export const TIMEOUT_FIVE_MINUTES = 300000 // 5 minutes
/**
 * Determines the timeout.
 *
 * @param {number} debtorsAge
 * @param {ConfigName} [configName]
 * @returns {number | null} The timeout duration in milliseconds or null if no timeout is applicable.
 */
export const determineTimeout = (
  debtorsAge: number,
  configName?: ConfigName
): number | null => {
  const ageGroup = getAgeGroupFromAge(debtorsAge)

  if (configName && CONFIGS_WITH_AGE_BASED_TIMEOUT.has(configName)) {
    if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
      return TIMEOUT_THREE_MINUTES
    }

    if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
      return TIMEOUT_TWO_MINUTES
    }
  }

  if (configName === CONFIG_DDF_RCE_DAC_CHOICE) {
    if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
      return TIMEOUT_THREE_MINUTES
    }

    if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
      return TIMEOUT_ONE_MINUTE
    }
  }

  if (configName === CONFIG_DDF) {
    if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
      return TIMEOUT_THREE_MINUTES
    }

    if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
      return TIMEOUT_ONE_MINUTE
    }
  }

  if (configName === CONFIG_DDF_SMAVA) {
    if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
      return TIMEOUT_THREE_MINUTES
    }
    if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
      return TIMEOUT_TWO_MINUTES
    }
    return TIMEOUT_FIVE_MINUTES
  }

  return null
}
